import { render } from "./ItemForm.vue?vue&type=template&id=54900d23&scoped=true"
import script from "./ItemForm.vue?vue&type=script&lang=js"
export * from "./ItemForm.vue?vue&type=script&lang=js"

import "./ItemForm.vue?vue&type=style&index=0&id=54900d23&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54900d23"

export default script